// extracted by mini-css-extract-plugin
export var position = "jobDescription-module--position--P7z0k";